import * as Yup from 'yup'

import { FormSchema } from '../../../ana-toolbox'
import {
  allergiesAndMedications,
  consents,
  contactDetails,
  insuranceFields,
  personalInformationFields,
  profileInterest,
  wishesAndExpectations,
} from '../fields/main'

Yup.setLocale({
  mixed: {
    required: 'generic_form_error',
  },
  number: {
    min: (values) => ({ key: 'number_min_error', values }),
    max: (values) => ({ key: 'number_max_error', values }),
  },
})

const fields = {
  ...personalInformationFields,
  ...contactDetails,
  ...insuranceFields(),
  ...allergiesAndMedications,
  ...wishesAndExpectations(),
  ...consents,
  ...profileInterest,
}

export const combinedFields = {
  ...fields,
  allergyPassField: {
    label: 'field.do_you_have_an_allergy_pass',
    name: 'allergyPass',
    inputProps: {
      withText: true,
    },
    validation: Yup.boolean(),
  },
}

export const personalInformationSchema = Yup.object().shape({
  [combinedFields.gender.name]: combinedFields.gender.validation,
  [combinedFields.firstName.name]: combinedFields.firstName.validation,
  [combinedFields.lastName.name]: combinedFields.lastName.validation,
  [combinedFields.birthday.name]: combinedFields.birthday.validation,
  [combinedFields.placeOfBirth.name]: combinedFields.placeOfBirth.validation,
  [combinedFields.bodyWeightInKg.name]: combinedFields.bodyWeightInKg.validation,
  [combinedFields.bodyHeightInCm.name]: combinedFields.bodyHeightInCm.validation,
})

export const addressSchema = Yup.object().shape({
  [combinedFields.street.name]: combinedFields.street.validation,
  [combinedFields.zipCode.name]: combinedFields.zipCode.validation,
  [combinedFields.city.name]: combinedFields.city.validation,
  [combinedFields.email.name]: combinedFields.email.validation,
  [combinedFields.phone.name]: combinedFields.phone.validation,
})

export const lifestyleSchema = Yup.object().shape({
  [combinedFields.occupation.name]: combinedFields.occupation.validation,
  [combinedFields.cigaretteConsumption.name]: combinedFields.cigaretteConsumption.validation,
  [combinedFields.alcoholConsumption.name]: combinedFields.alcoholConsumption.validation,
  [combinedFields.drugConsumption.name]: combinedFields.drugConsumption.validation,
  [combinedFields.medications.name]: combinedFields.medications.validation,
})

export const preparationsSchema = Yup.object().shape({
  [combinedFields.isPregnant.name]: combinedFields.isPregnant.validation,
  [combinedFields.pregnantMonths.name]: combinedFields.pregnantMonths.validation,
})

export const insuranceSchema = Yup.object().shape({
  [combinedFields.type.name]: combinedFields.type.validation,
  [combinedFields.insuranceCompany.name]: combinedFields.insuranceCompany.validation,
  [combinedFields.hasCareLevel.name]: combinedFields.hasCareLevel.validation,
  [combinedFields.careLevelLimitedInTime.name]: combinedFields.careLevelLimitedInTime.validation,
  [combinedFields.entitledToIntegrationAssistance.name]: combinedFields.entitledToIntegrationAssistance.validation,
  [combinedFields.integrationAssistanceBasedOnType.name]: combinedFields.integrationAssistanceBasedOnType.validation,
  [combinedFields.holderFirstName.name]: combinedFields.holderFirstName.validation,
  [combinedFields.holderLastName.name]: combinedFields.holderLastName.validation,
  [combinedFields.holderBirthday.name]: combinedFields.holderBirthday.validation,
  [combinedFields.holderStreet.name]: combinedFields.holderStreet.validation,
  [combinedFields.holderCity.name]: combinedFields.holderCity.validation,
  [combinedFields.holderZipcode.name]: combinedFields.holderZipcode.validation,
  [combinedFields.dentalInsuranceCompany.name]: combinedFields.dentalInsuranceCompany.validation,
})

export const formSchema = Yup.object()
  .shape({
    dataTruthyness: Yup.boolean().oneOf([true], 'data_truthyness_error').required('data_truthyness_error'),
  })
  .concat(personalInformationSchema as FormSchema)
  .concat(addressSchema as FormSchema)
  .concat(lifestyleSchema as FormSchema)
  .concat(insuranceSchema as FormSchema)
  .concat(preparationsSchema as FormSchema)
